import { makeStyles } from '@material-ui/styles';
import { colors, fonts, screen } from 'components/styles/variables';
import selectedCheckIcon from 'public/static/images/srp/selectedCheck.svg';

export const useStyles = makeStyles({
  radiusModal: {
    borderRadius: '8px',
  },

  listItem: {
    cursor: 'pointer',
    fontFamily: fonts.default,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.2px',
    color: colors.BLACK,
    padding: '12px 24px',
    '&:hover': {
      backgroundColor: colors.G1,
    },
  },

  selected: {
    '&$selected': {
      backgroundColor: colors.WHITE,
      color: colors.ALR1,
    },
  },

  selectedIcon: {
    backgroundImage: `url(${selectedCheckIcon})`,
    width: '14px',
    height: '9px',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    left: '7px',
  },

  scrollingContainer: {
    overflowY: 'auto',
    [`@media (min-width: ${screen.mobileMax})`]: {
      height: 'calc(70vh - 60px)',
      maxHeight: '465px',
      minHeight: '200px',
    },
  },
});
